import { CSSProperties } from "react";

export const style: CSSProperties = {
  width: "100vw",
  marginTop: "150px",
  minHeight: "80vh",
  backgroundColor: "#fff",
};
